import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { ImportJobDto } from '../../../models/user/dto/import-job.dto';

/**
 * Discard a previewed (READY) import before it runs. Terminal — the server also
 * reclaims the stored CSV so an abandoned preview doesn't sit on a text column.
 */
export const useCancelImportJob = (organizationId: string) => {
  const client = useApiClient();

  return useMutation({
    mutationFn: (jobId: string) =>
      client.fetchApi<ImportJobDto, undefined>({
        endpoint: `users/imports/${jobId}/cancel?organizationId=${organizationId}`,
        method: 'POST',
      }),
  });
};
